<div class="wrapper">

  <div>
    <app-navegacao (changeLanguage)="switchLanguage($event)" 
                   (sidebarToggle)="onSidebarToggle($event)"
                   *ngIf="tratarLogado && logado" 
                   [habilitar]="habilitar" 
                   [menu]="itensMenu"
                   style="height: 100%;"></app-navegacao>
  </div>
  <app-barra-notificacao *ngIf="tratarLogado && logado" style="height: 100%;"></app-barra-notificacao>
  <div id="content" class="content-inactive">
    <div *ngIf="tratarLogado && logado" id="titulo">
      <div class="float-left">
        <button type="button" appClickOutside class="btn btn-default" (click)="toogleMenu();" id="sidebarCollapse">
          <em class="fa fa-bars"></em>
        </button>
      </div>
      <div translate class="float-left" style="margin: 12px 0px 0px 8px; font-weight: bold; color:rgb(121, 121, 121);">
        {{'barraNavegacao.ola'}}
        <ng-container>
          {{getUser}}
        </ng-container>
      </div>
      <div class="float-right">
        <button *ngIf="habilitar" pTooltip="Verificar atualizações" tooltipPosition="top" type="button"
          class="btn btn-info mr-2" routerLink="atualizacao_portal">
          <div style="width: 15px; height: 23px;">
            <i *ngIf="badgeValue != null" class="pi pi-download icone mr-4" pBadge [(value)]="badgeValue"
              severity="warning"></i>
            <i *ngIf="badgeValue == null" class="pi pi-download icone mr-4"></i>
          </div>
        </button>
        <button type="button" pTooltip="Informação versão" tooltipPosition="top" class="btn btn-info mr-1"
          routerLink="sobre">
          <div>
            <em class="fas fa-info"></em>
          </div>
        </button>
        <button type="button" class="btn btn-info mr-1 btn-comunicado" 
                [class.has-notification]="temNotificacaoComunicado" 
                routerLink="comunicado">
          <div class="shaking">
            <em class="fas fa-envelope"></em>
          </div>
          <span class="notification-badge" *ngIf="temNotificacaoComunicado"></span>
        </button>
        <button type="button" class="btn btn-primary" routerLink="logout">
          <em class="fas fa-sign-out-alt"></em> Logout
        </button>
      </div>
      <div class="clear"></div>
    </div>
    <div class="barra-local" *ngIf="tratarLogado && logado">
      <breadcrumb translate [allowBootstrap]="true"></breadcrumb>
      <div class="clear"></div>
    </div>
    <router-outlet></router-outlet>
  </div>
  <p-dialog [(visible)]="displayBasic2" header="Atenção" [style]="{width: '26vw'}" [modal]="true">
    <p>Sessão Expirada. Deseja continuar? <a>{{ contador }}</a></p>
    <ng-template pTemplate="footer">
      <button pButton (click)="retornoLogin()" icon="pi pi-times" label="No"></button>
      <button pButton (click)="getToken()" icon="pi pi-check" label="Yes"></button>
    </ng-template>
  </p-dialog>
</div>